import { SanalSinavSystemActionTypes } from "../constants/action-types";
export const setSanalSinavSystemInfo = (info) => {
    return {
        type: SanalSinavSystemActionTypes.SET_SANAL_SINAV_BILGISI,
        payload: info
    }
}